import React from "react";

export default (props) => {

    return (
        <button className="blue-arrow-button" {...props}>&gt;</button>
    );

}
